import keyMirror from 'keymirror';
import { createAction } from 'redux-actions';

export const types = keyMirror({
  ORDERS_API_HOC_RESET: null,
});

export const resetAddProductApiHOC = createAction(types.ORDERS_API_HOC_RESET);



// WEBPACK FOOTER //
// ./src/components/apiHOCs/OrdersApiHOC/actions.js